import React, { memo, useEffect, useState } from "react"
import { graphql, Link } from "gatsby"
import {
  breakpoints,
  wrapper,
  color,
} from "../utils/style"
import LayoutMain from "../components/shared/layoutMainPage"
import SEO from "../components/SEO/SEO"
import styled from "@emotion/styled"
import PlayForFree from "../components/Content/Home/PlayForFree"
import Parallax from "../components/shared/Parallax"
import Demo10Games from "../components/Content/Home/SlotGamesNoQuery"
import GetWindowWidth from "../components/shared/GetWindowWidth"
import Img from "gatsby-image"
import Contacts from "../components/Content/Home/Contacts"
import HowToPlay from "../components/Content/Home/HowToPlay"
import { scroller } from "react-scroll"
import Blog from "../components/Content/Home/Blog"
import Promotion from "../components/Content/Home/Promotion"

const WrapperDesktop = styled("div")`
  ${wrapper}
  .h1 {
    max-width: 595px;
    margin-top: -60px;
    font-weight: 500;
    font-size: 36px;
    line-height: 48px;
  }
  .decorative-line {
    width: 288px;
    height: 2px;
    background: ${color.pink};
    margin: 20px 0;
  }
  .button-group {
    margin-top: 20px;
    .pink-button {
      margin-right: 24px;
    }
  }
  @media (max-width: ${breakpoints.xl}) {
    .h1 {
      margin-top: 0;
    }
  }
  @media (max-width: ${breakpoints.sm}) {
    .h1 {
      font-size: 24px;
      line-height: 32px;
    }
    .decorative-line {
      width: 100%;
      margin: 16px 0;
    }
    .button-group {
      margin-top: 16px;
    }
  }
`

const Section = styled("div")`
  min-height: 100vh;
  padding-top: 60px;
  &.section1 {
    margin-top: -80px;
    padding: 0;
  }
  @media (max-width: ${breakpoints.lg}) {
    min-height: auto;
    padding-top: 30px;
    &.section1 {
      margin-top: 0;
    }
  }
`

const TopBanner = styled("div")`
  display: flex;
  justify-content: space-between;
  .top-banner-1 {
    width: 100%;
    height: 100%;
    max-width: 596px;
    margin-left: 17%;
  }
  .top-banner-2 {
    width: 100%;
    height: 100%;
    max-width: 790px;
    margin-top: 60px;
    margin-right: 5%;
  }
  @media (max-width: ${breakpoints.lg}) {
    .top-banner-1 {
      margin-left: 20px;
    }
  }
`

const HomePage = ({ data }) => {
  const windowWidth = GetWindowWidth()
  const isDesktop = windowWidth > 600
  const isScrolling = windowWidth > 960
  const homePageNode = data.allWordpressPage.edges[0].node
  const metaTitle =
    homePageNode.yoast_meta && homePageNode.yoast_meta.yoast_wpseo_title
      ? homePageNode.yoast_meta.yoast_wpseo_title
      : homePageNode.title + process.env.OWNER
  const metaDesc =
    homePageNode.yoast_meta && homePageNode.yoast_meta.yoast_wpseo_metadesc
      ? homePageNode.yoast_meta.yoast_wpseo_metadesc
      : ""
  const socialImage = homePageNode.featured_media?.localFile?.publicURL
  const slider = homePageNode.acf.top_slider
  const slideDesktop1 = slider[0]
  const slideDesktop2 = slider[1]
  const sliderMobile = homePageNode.acf.top_slider_mobile
  const slideMobile1 = sliderMobile[0]
  const showSlider = slider && slider.length > 0
  const showSliderMobile = sliderMobile && sliderMobile.length > 0
  const showPlayForFree = homePageNode.acf.play_for_free
  const playForFreeMobile = homePageNode.acf.play_for_free_mobile
  const showPlayForFreeMobile =
    playForFreeMobile && playForFreeMobile.length > 0
  const playForFreeIframe = homePageNode?.acf?.play_for_free_video_file
  const playForFreeTitle = homePageNode.acf.play_for_free_title
  const playForFreeDescription = homePageNode.acf.play_for_free_description
  const playForFreeVideoCover = homePageNode.acf.play_for_free_video_cover
  const showDemoGames = homePageNode.acf.demo_games_10.length > 0
  const demoGames = homePageNode.acf.demo_games_10
  const topBannerTitle = homePageNode.acf.top_banner_title
  const topBannerDescription = homePageNode.acf.top_banner_description
  const contactText = homePageNode.acf.contact_text
  const howToPlayText = homePageNode.acf.how_to_play_text
  const howToPlayIframe = homePageNode?.acf?.how_to_play_iframe
  const howToPlayVideoCover = homePageNode.acf.how_to_play_video_cover
  const promotionPosts = data.allWordpressPost.edges
  const promotionCategory = data.allWordpressCategory.edges[0].node

  const [activeSection, setActiveSection] = useState(1)


  const handleScroll = (e) => {
    e = e || window.event

    const detail = e.deltaY || e.detail || e.wheelDelta

    if(detail === 10) {
      setActiveSection(activeSection === 7 ? activeSection : activeSection + 1)
    }
    if(detail === -10) {
      setActiveSection(activeSection === 1 ? activeSection : activeSection - 1)
    }
    if(isScrolling) {
      scroller.scrollTo(`section${activeSection}`, {
        duration: 600,
        delay: 0,
        smooth: "easeInOutQuart",
        offset: windowWidth > 1400 ? -120 : 30,
      });
    }
  }

  useEffect(() => {
    if('onwheel' in window) {
      window.addEventListener('wheel', handleScroll, false)
    }
    if ('onmousewheel' in window) {
      window.addEventListener('mousewheel', handleScroll, false)
    }
    return () => {
      if('onwheel' in window) {
        window.removeEventListener('wheel', handleScroll, false)
      }
      if ('onmousewheel' in window) {
        window.removeEventListener('mousewheel', handleScroll, false)
      }
    }
  },[activeSection])

  return (
    <LayoutMain>
      <SEO title={metaTitle} description={metaDesc} showSchema={true} socialImage={socialImage} />
      {isDesktop && <Parallax />}
      <div id="home-content-all" className="with-overflow-slider">

        <Section className="section1">
          {isDesktop ? (
            <>
              {showSlider && (
                <TopBanner>
                  {slideDesktop1 && (
                    <div className="top-banner-1">
                      <Img
                        fluid={slideDesktop1.localFile.childImageSharp.fluid}
                        alt={
                          slideDesktop1.alt_text
                            ? slideDesktop1.alt_text
                            : "top banner 1"
                        }
                        fadeIn={false}
                        loading="eager"
                      />
                    </div>
                  )}
                  {slideDesktop2 && (
                    <div className="top-banner-2">
                      <Img
                        fluid={slideDesktop2.localFile.childImageSharp.fluid}
                        alt={
                          slideDesktop2.alt_text
                            ? slideDesktop2.alt_text
                            : "top banner 2"
                        }
                        fadeIn={false}
                        loading="eager"
                      />
                    </div>
                  )}
                </TopBanner>
              )}
            </>
          ) : (
            <>
              {showSliderMobile && (
                <div className="mobile-banner">
                  <Img
                    fluid={slideMobile1.localFile.childImageSharp.fluid}
                    alt={
                      slideMobile1.alt_text
                        ? slideMobile1.alt_text
                        : "top banner mobile"
                    }
                    fadeIn={false}
                    loading="eager"
                  />
                </div>
              )}
            </>
          )}

          <WrapperDesktop>
            {topBannerTitle && (
              <h1 className="h1 rich-design">{topBannerTitle}</h1>
            )}
            <div className="decorative-line" />
            {topBannerDescription && <p>{topBannerDescription}</p>}

            <div className="button-group">
              <Link
                to={"/918kiss-download/"}
                className="button pink-button download-button"
              >
                ดาวน์โหลด
              </Link>
              <a href="/register/?register_type=onsitegames" className="button white-button">
                ลงชื่อเข้าใช้
              </a>
            </div>
          </WrapperDesktop>
        </Section>

        <Section id="section2">
          <WrapperDesktop>
            {showPlayForFree && isDesktop && (
              <PlayForFree
                iframe={playForFreeIframe?.source_url}
                title={playForFreeTitle}
                description={playForFreeDescription}
                video_cover={playForFreeVideoCover}
                play_free={showPlayForFree}
              />
            )}

            {showPlayForFreeMobile && !isDesktop && (
              <PlayForFree
                iframe={playForFreeIframe?.source_url}
                title={playForFreeTitle}
                description={playForFreeDescription}
                video_cover={playForFreeVideoCover}
                play_free={playForFreeMobile}
              />
            )}
          </WrapperDesktop>
        </Section>



        <WrapperDesktop>
          <Section id="section3">
            <Promotion promotionPosts={promotionPosts} promotionCategory={promotionCategory}/>
          </Section>

          <Section id="section4">
            {showDemoGames && <Demo10Games slotSlides={demoGames} />}
          </Section>

          <Section id="section5">
            <HowToPlay
              how_to_play_text={howToPlayText}
              iframe={howToPlayIframe}
              video_cover={howToPlayVideoCover}
            />
          </Section>

          <Section id="section6">
            <Blog/>
          </Section>

          <Section id="section7">
            <Contacts contact_text={contactText} img={slideDesktop2} />
          </Section>
        </WrapperDesktop>
      </div>
    </LayoutMain>
  )
}

export default memo(HomePage)

// Set here the ID of the home page.
export const pageQuery = graphql`
  query {
    allWordpressPage(filter: { slug: { eq: "home-page" } }) {
      edges {
        node {
          title
          content
          wordpress_id
          featured_media {
            alt_text
            localFile {
              publicURL
              childImageSharp {
                fluid(maxWidth: 1100) {
                  ...GatsbyImageSharpFluid_withWebp_noBase64
                }
              }
            }
          }
          yoast_meta {
            yoast_wpseo_title
            yoast_wpseo_metadesc
          }
          acf {
            top_slider {
              alt_text
              title
              path
              acf {
                slide_title
                slide_description
                slide_url
              }
              localFile {
                childImageSharp {
                  fluid(maxWidth: 800) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
            top_slider_mobile {
              alt_text
              title
              path
              acf {
                slide_title
                slide_description
                slide_url
              }
              localFile {
                childImageSharp {
                  fluid(maxWidth: 600) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
            top_banner_title
            top_banner_description
            play_for_free_title
            play_for_free_description
            play_for_free_video_file {
              source_url
            }
            play_for_free_video_cover {
              alt_text
              title
              path
              localFile {
                childImageSharp {
                  fluid(maxWidth: 400) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
            play_for_free {
              alt_text
              title
              path
              acf {
                slide_url
                slide_title
                slide_description
              }
              localFile {
                childImageSharp {
                  fluid(maxWidth: 268) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
            play_for_free_mobile {
              alt_text
              title
              path
              acf {
                slide_url
                slide_title
                slide_description
              }
              localFile {
                childImageSharp {
                  fluid(maxWidth: 208) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
            demo_games_10 {
              alt_text
              title
              id
              acf {
                slide_url
                slide_title
                slide_description
              }
              localFile {
                childImageSharp {
                  fluid(maxWidth: 280) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
            game_providers {
              alt_text
              id
              localFile {
                childImageSharp {
                  fluid(maxWidth: 160) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
              acf {
                slide_url
              }
            }
            popular_games {
              alt_text
              title
              id
              acf {
                slide_url
                slide_title
                slide_description
              }
              localFile {
                childImageSharp {
                  fluid(maxWidth: 392) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
            how_to_play_text
            how_to_play_iframe
            how_to_play_video_cover {
              alt_text
              title
              path
              localFile {
                childImageSharp {
                  fluid(maxWidth: 600) {
                    ...GatsbyImageSharpFluid_withWebp_noBase64
                  }
                }
              }
            }
            contact_text
          }
        }
      }
    }
    allWordpressPost(
      sort: { fields: date, order: DESC }
      filter: { categories: { elemMatch: { wordpress_id: { eq: 63 } } } }
      limit: 4
    ) {
      edges {
        node {
          id
          title
          excerpt
          slug
          featured_media {
            alt_text
            localFile {
              childImageSharp {
                fluid(maxWidth: 500) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
    }
    allWordpressCategory(filter: { wordpress_id: { eq: 63 } }) {
      edges {
        node {
          id
          name
          description
        }
      }
    }
  }
`
